import { Status } from '@tiendanube/common/src/enums';
import { FulfillmentStatusType, StatusType } from '../Orders/ordersService';

export const METAFIELD_FILTER_PREFIX = 'mf-';

export const defaultStockIssuesFilters = {
  status: Status.OPEN as StatusType,
  fulfillmentStatus: Status.UNPACKED as FulfillmentStatusType,
  stockIssues: 'true',
};
